import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import SelectPayDisputesErrorIllustration from '../../../common/illustrations/select-pay/disputes-error';
import GenericError from '../../../common/generic-error';
import BusinessErrorPromoLimitReached from '../../../common/illustrations/select-pay/promo-limit';
import { selectPayMutationErrorCodes } from '../../../../hooks/use-select-pay-mutation';
import { CardHeader } from '../../../common/card-header';
import SelectPayGenericError from '../generic-error';
var getCorrespondentErrorComponent = function (code) {
    if (code === selectPayMutationErrorCodes.errorLimitCode)
        return (_jsx(GenericError, { image: _jsx(BusinessErrorPromoLimitReached, {}), titleKey: "selectPay.errorPromoLimitReachedHeading", subtitleKey: "selectPay.errorPromoLimitReachedSubHeading" }));
    if (code === selectPayMutationErrorCodes.errorDisputesCode)
        return (_jsx(GenericError, { image: _jsx(SelectPayDisputesErrorIllustration, {}), titleKey: "selectPay.transactionDisputesErrorHeading", subtitleKey: "selectPay.transactionDisputesErrorSubHeading" }));
    return null;
};
var nonGenericErrors = [
    selectPayMutationErrorCodes.errorLimitCode,
    selectPayMutationErrorCodes.errorDisputesCode
];
var BusinessError = function (_a) {
    var error = _a.error, selectedTransaction = _a.selectedTransaction;
    if (!selectedTransaction)
        return null;
    var businessError = ((error === null || error === void 0 ? void 0 : error.businessErrors) || [
        {
            code: 'unhandled exception'
        }
    ])[0];
    if (!nonGenericErrors.includes(businessError.code)) {
        return _jsx(SelectPayGenericError, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(CardHeader, {}), getCorrespondentErrorComponent(businessError.code)] }));
};
export default BusinessError;
//# sourceMappingURL=index.js.map